export default class Quests {
	static STATUS_ACTIVATABLE = 'activatable';	// не просмотренный квест
	static STATUS_PROCESSING = 'processing';	// квест в процессе выполнения
	static STATUS_DONE = 'done';				// завершенный квест
	
	static REWARD_XP = 'xp';
	static REWARD_RESOURCES = 'resources';
	static REWARD_TROOPS = 'troops';
	static REWARD_SILVER = 'silver';
	static REWARD_ITEM = 'item';
	static REWARD_ONLY_TEXT = 'only-text';
	static REWARD_GOLD = 'gold';
	static REWARD_CULTURE_POINTS = 'culture-points';
	static REWARD_TREASURES = 'treasures';
	static REWARD_ADVENTURES_POINTS = 'adventures-points';
	static REWARD_BUILDING_LEVEL = 'building-level';
	static REWARD_PLUS_ACCOUNT = 'plus-account';
	static REWARD_RESOURCE_BONUS = 'resource-bonus';
	static REWARD_CROP_BONUS = 'crop-bonus';
}